/* ★ GAMBAR PRODUK TAMBAHAN — sumber dari MY PRODUCTS (2026-09-11)
 *
 * Kad Workspace boleh membawa sehingga 4 gambar TAMBAHAN (5 termasuk gambar utama)
 * dalam medan `extraImageUrls`; skrip Flow melekatkan kesemuanya sebagai rujukan
 * supaya Nano Banana mengenali produk dengan tepat. Keputusan user 2026-09-05:
 * tambah/buang gambar dibuat di halaman MY PRODUCTS (borang "Data Produk"),
 * BUKAN pada kad Workspace (kad hanya papar + susun).
 *
 * Tiga sumber gambar tambahan (dua di sini, satu di tempat lain):
 *   1. GALERI SCRAPE TikTok — `scrapedData.gallery` (≤10 pautan CDN TikTok yang
 *      Import Products simpan). Pautan sahaja: tiada muat naik, tiada kos storan,
 *      tiada kuota. Disahkan 2026-09-11: 33/111 item akaun owner ada galeri,
 *      SEMUANYA tepat 10 pautan (item lama sebelum galeri direkod tiada).
 *   2. PERANTI pelanggan — dimampat ≤1400px JPEG DAHULU (peraturan gambar produk,
 *      corak changelog), naik ke `users/{uid}/library/{folder}/…` melalui
 *      `muatNaikGambarProduk` LibraryView (kaunter 5GB naik; ganti/padam turun).
 *   3. AGENT (Agent Saya) — gambar yang ChatGPT/Gemini jana ditulis TERUS pada kad
 *      oleh larian agent (utils/agentGambar.js), bukan melalui sini.
 *
 * ⛔ Gambar galeri (CDN TikTok) dan gambar peranti duduk dalam senarai yang SAMA;
 *    yang membezakan hanya alamatnya. `padamGambarSimpanan` LibraryView menapis
 *    ikut laluan `users/{uid}/library/` — pautan CDN tidak pernah disentuh.
 */
import { MAKS_GAMBAR_TAMBAHAN } from './agentGambar';

export const MAKS_TAMBAHAN = MAKS_GAMBAR_TAMBAHAN;
export const MAKS_SAIZ_FAIL = 5 * 1024 * 1024;   // 5 MB sebelum mampat — sama seperti gambar utama

const adaHttp = (u) => typeof u === 'string' && /^https?:\/\//i.test(u);

/* Senarai gambar tambahan yang SAH pada item/kad (maks 4, pautan sahaja). */
export function senaraiTambahan(item) {
    return Array.isArray(item?.extraImageUrls)
        ? item.extraImageUrls.filter(adaHttp).slice(0, MAKS_TAMBAHAN)
        : [];
}

/* Galeri scrape TikTok untuk item ini — gambar utama dan pendua dibuang. */
export function galeriProduk(item) {
    const sd = item?.scrapedData || {};
    const sumber = Array.isArray(sd.gallery) && sd.gallery.length ? sd.gallery
        : (Array.isArray(sd.rawImages) ? sd.rawImages : []);
    const utama = String(item?.imageUrl || '');
    const dilihat = new Set();
    const hasil = [];
    for (const u of sumber) {
        if (!adaHttp(u) || u === utama || dilihat.has(u)) continue;
        dilihat.add(u);
        hasil.push(u);
    }
    return hasil;
}

/* Mampat fail gambar ke JPEG ≤ maxPx sisi terpanjang. Fail kecil yang sudah muat
   dikekalkan kalau ia JPEG/PNG (elak kualiti turun tanpa faedah). Gagal mampat
   (fail rosak / format pelik) → pulangkan fail ASAL, biar muat naik cuba juga —
   lebih baik gambar besar daripada gambar hilang senyap. */
export async function mampatFailGambar(file, { maxPx = 1400, kualiti = 0.88 } = {}) {
    if (!file) return file;
    try {
        const bitmap = await createImageBitmap(file);
        const { width: w0, height: h0 } = bitmap;
        const skala = Math.min(1, maxPx / Math.max(w0, h0));
        const sudahJpeg = /^image\/(jpeg|jpg)$/i.test(file.type || '');
        if (skala === 1 && sudahJpeg && file.size <= 500 * 1024) { bitmap.close?.(); return file; }
        const w = Math.max(1, Math.round(w0 * skala));
        const h = Math.max(1, Math.round(h0 * skala));
        const canvas = document.createElement('canvas');
        canvas.width = w; canvas.height = h;
        const g = canvas.getContext('2d');
        g.fillStyle = '#ffffff';            // JPEG tiada lutsinar — isi putih dahulu
        g.fillRect(0, 0, w, h);
        g.drawImage(bitmap, 0, 0, w, h);
        bitmap.close?.();
        const blob = await new Promise((res) => canvas.toBlob(res, 'image/jpeg', kualiti));
        if (!blob) return file;
        const nama = (file.name || 'gambar').replace(/\.[^.]+$/, '') + '.jpg';
        return new File([blob], nama, { type: 'image/jpeg' });
    } catch (e) {
        console.warn('[GambarTambahan] mampat gagal — guna fail asal:', e?.message || e);
        return file;
    }
}
